export default {
	"description": "识别成功",
	"error_code": 0,
	"result": {
		"name": {
			"position": {
				"width": 77,
				"top": 45,
				"height": 28,
				"left": 122
			},
			"chinese_key": "姓名",
			"score": 0.897336,
			"words": "吴吴吴",
			"quad": "122,45,199,45,199,73,122,73"
		},
		"gender": {
			"position": {
				"width": 312,
				"top": 393,
				"height": 30,
				"left": 205
			},
			"chinese_key": "性别",
			"score": 0.999956,
			"words": "女",
			"quad": "205,393,517,397,517,423,205,420"
		},
		"nationality": {
			"position": {
				"width": 29,
				"top": 100,
				"height": 24,
				"left": 249
			},
			"chinese_key": "民族",
			"score": 0.988582,
			"words": "汉",
			"quad": "249,100,278,100,278,124,249,124"
		},
		"birthdate": {
			"position": {
				"width": 312,
				"top": 393,
				"height": 30,
				"left": 205
			},
			"chinese_key": "出生",
			"score": 0.999956,
			"words": "1994年5月4日",
			"quad": "205,393,517,397,517,423,205,420"
		},
		"address": {
			"position": {
				"width": 290,
				"top": 189,
				"height": 57,
				"left": 120
			},
			"chinese_key": "住址",
			"score": 0.999244,
			"words": "广东省佛山市禅城区",
			"quad": "120,189,410,191,410,246,120,246"
		},
		"idno": {
			"position": {
				"width": 312,
				"top": 393,
				"height": 30,
				"left": 205
			},
			"chinese_key": "公民身份号码",
			"score": 0.999956,
			"words": "443333199405044524",
			"quad": "205,393,517,397,517,423,205,420"
		},
		"issued": {
			"position": {
				"width": 231,
				"top": 349,
				"height": 25,
				"left": 154
			},
			"chinese_key": "签发机关",
			"score": 0.999877,
			"words": "佛山市公安局禅城分局",
			"quad": "154,349,385,349,385,374,154,374"
		},
		"valid": {
			"position": {
				"width": 246,
				"top": 311,
				"height": 20,
				"left": 152
			},
			"chinese_key": "有效期限",
			"score": 0.977478,
			"words": "2014.01.20-2014.04.20",
			"quad": "152,311,398,311,398,331,152,331"
		}
	},
	"request_id": "f45cf1c0563611ebb75100163e0d18d7",
	"recognize_time": 497,
	"dbg_xml": "",
	"rotation": 0
}


//////////////////
// WEBPACK FOOTER
// ./static/preview_data/temp_id_card.js
// module id = null
// module chunks = 